import { Dialog, dialogClasses, styled } from "@mui/material"
import type { PropsWithChildren } from "react"

export const SecurityDialog = ({
  open,
  children,
}: PropsWithChildren<{ open: boolean }>) => {
  return (
    <StyledSecurityDialog
      open={open}
      slotProps={{
        backdrop: {
          style: { backdropFilter: "blur(5px)" },
        },
      }}
      fullWidth
    >
      {children}
    </StyledSecurityDialog>
  )
}

const StyledSecurityDialog = styled(Dialog)(({ theme }) => ({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: "450px",
  },
}))
